import React from 'react'
import { FaRobot } from 'react-icons/fa'

export const ABSAT_BOT_ID = 'absat-bot';

// التذكرة / المشروع اتعمل تلقائياً (الأعمال المجدولة أو النظام).
export const isAbsatBot = (item) => String(item?.createdBy || '') === ABSAT_BOT_ID;

// شارة مميزة لـ Absat Bot بدل اسم المنشئ.
const AbsatBotBadge = ({ size = 'md', scheduled = false, lang = 'ar' }) => {
    const small = size === 'sm';
    return (
        <span
            title={lang === 'ar' ? 'أُنشئت تلقائياً بواسطة Absat Bot' : 'Created automatically by Absat Bot'}
            style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: small ? 4 : 6,
                padding: small ? '1px 8px 1px 2px' : '2px 10px 2px 3px',
                borderRadius: 999,
                background: 'linear-gradient(90deg, #261759, #6d28d9)',
                color: '#fff',
                fontSize: small ? 10 : 11.5,
                fontWeight: 900,
                whiteSpace: 'nowrap',
                boxShadow: '0 2px 8px rgba(109,40,217,.25)',
                direction: 'ltr',
            }}
        >
            <span style={{ width: small ? 16 : 20, height: small ? 16 : 20, borderRadius: '50%', background: 'rgba(255,255,255,.18)', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
                <FaRobot size={small ? 9 : 11} aria-hidden="true" />
            </span>
            Absat Bot
            {scheduled && (
                <span style={{ padding: '0 6px', borderRadius: 999, background: 'rgba(255,255,255,.2)', fontSize: small ? 9 : 10, fontWeight: 800 }}>
                    {lang === 'ar' ? 'مجدولة' : 'Scheduled'}
                </span>
            )}
        </span>
    );
};

export default AbsatBotBadge
